export const workPatternName = ({ workPatterns }) => {
  if (workPatterns.length)
    return workPatterns.reduce((acc, workPatterns) => {
      const { value, description } = workPatterns
      acc[value] = description
      return acc
    }, {})
  return {}
}
